// Enums matching backend Prisma schema

export enum ShopStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED',
}

export enum ProviderType {
  BARBER = 'BARBER',
  HAIRSTYLIST = 'HAIRSTYLIST',
  HAIR_BRAIDER = 'HAIR_BRAIDER',
  NAIL_TECHNICIAN = 'NAIL_TECHNICIAN',
  ESTHETICIAN = 'ESTHETICIAN',
}

export enum AppointmentStatus {
  SCHEDULED = 'SCHEDULED',
  WAITING = 'WAITING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  NO_SHOW = 'NO_SHOW',
}

export enum AppointmentSource {
  SELF_SERVE = 'SELF_SERVE',
  STAFF_ASSISTED = 'STAFF_ASSISTED',
  WALK_IN = 'WALK_IN',
  RETROACTIVE = 'RETROACTIVE',
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
}

export enum ServiceType {
  HAIRCUT = 'HAIRCUT',
  SHAVE = 'SHAVE',
  BEARD_TRIM = 'BEARD_TRIM',
  HAIR_COLORING = 'HAIR_COLORING',
  STYLING = 'STYLING',
  MANICURE = 'MANICURE',
  PEDICURE = 'PEDICURE',
  FACIAL = 'FACIAL',
  WAXING = 'WAXING',
  OTHER = 'OTHER',
  // Additional service types for compatibility
  BUSINESS_SERVICE = 'BUSINESS_SERVICE',
  PROVIDER_SERVICE = 'PROVIDER_SERVICE',
  SHOP_SERVICE = 'SHOP_SERVICE',
}

export enum ServiceKind {
  BASE = 'BASE',
  ADD_ON = 'ADD_ON',
  STANDALONE = 'STANDALONE',
}

export enum BookingMode {
  LEGACY = 'LEGACY',
  CATALOG_V1 = 'CATALOG_V1',
}

export enum AddOnBehavior {
  INCLUDED = 'INCLUDED',
  AVAILABLE = 'AVAILABLE',
  NOT_OFFERED = 'NOT_OFFERED',
}

export enum ShopVertical {
  BARBERSHOP = 'BARBERSHOP',
  HAIR_SALON = 'HAIR_SALON',
  BRAIDING_STUDIO = 'BRAIDING_STUDIO',
  NAIL_STUDIO = 'NAIL_STUDIO',
  ESTHETICS_STUDIO = 'ESTHETICS_STUDIO',
  MIXED_BEAUTY_SHOP = 'MIXED_BEAUTY_SHOP',
}

export enum ServiceFlowMode {
  QUEUE_FIRST = 'QUEUE_FIRST',
  SCHEDULE_FIRST = 'SCHEDULE_FIRST',
}

export enum ServiceFlowOverride {
  INHERIT = 'INHERIT',
  QUEUE_FIRST = 'QUEUE_FIRST',
  SCHEDULE_FIRST = 'SCHEDULE_FIRST',
}

export enum StaffRole {
  SHOP_OWNER = 'SHOP_OWNER',
  STAFF_PROVIDER = 'STAFF_PROVIDER',
  INDEPENDENT_PROVIDER = 'INDEPENDENT_PROVIDER',
}

export enum ShopMembershipRole {
  SHOP_OWNER = 'SHOP_OWNER',
  SHOP_MANAGER = 'SHOP_MANAGER',
  STAFF_PROVIDER = 'STAFF_PROVIDER',
}

export enum ContractType {
  BOOTH_RENTAL = 'BOOTH_RENTAL',
  COMMISSION = 'COMMISSION',
  HOURLY = 'HOURLY',
  SALARIED = 'SALARIED',
}

// Booth-rent contract type has two on-the-wire spellings:
//   - 'BOOTH_RENT'    — canonical Prisma enum (what the backend stores/returns)
//   - 'BOOTH_RENTAL'  — legacy alias still used by parts of the frontend
// Use this guard for read-side comparisons so reads stay correct regardless of
// which spelling the API returns. Outbound writes are normalized to
// 'BOOTH_RENT' by `canonicalizeContractType` in shared/api/shop/staff.api.ts.
export const isBoothRentContract = (value: string | null | undefined): boolean =>
  value === 'BOOTH_RENT' || value === 'BOOTH_RENTAL';

export enum FeeType {
  PERCENTAGE = 'PERCENTAGE',
  FLAT_RATE = 'FLAT_RATE',
}

export enum SubscriptionTier {
  SOLO = 'SOLO',
  PRO = 'PRO',
  PRO_PLUS = 'PRO_PLUS',
}

export enum PaymentMode {
  CARD = 'CARD',
  CASH = 'CASH',
  DEFERRED = 'DEFERRED',
  WAIVED = 'WAIVED',
}

export enum FeeCollectionMode {
  CLIENT_PAID = 'CLIENT_PAID',
  MERCHANT_ASSUMED = 'MERCHANT_ASSUMED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export type UserRole =
  | 'client'
  | 'independent_provider'
  | 'shop_owner'
  | 'shop_manager'
  | 'staff_provider'
  | 'pending_provider'
  | 'pending_staff';
